/** VScrollBar registration: the parser. */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseVScrollBar } from './parser';
const vScrollBarRegistration = {
    typeName: 'VScrollBar',
    parser: parseVScrollBar,
};
nodeRegistry.register(vScrollBarRegistration);
export * from './parser';
export * from './types';
//# sourceMappingURL=index.js.map